import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions'
import * as getters from './getters';
import myRender from './modules/render';
import app from './modules/app';
import row from './modules/row';
import left_sidebar from './modules/left_sidebar';
import module from './modules/module';
import main_dialog from './modules/main_dialog';
import color from './modules/color';
import align from './modules/align';
import options from '../base/options_config';
import image_upload from './modules/image_upload';
import set_link from './modules/set_link';
import add_form from './modules/add_form';
import add_form_item from './modules/add_form_item';
import full_screen_banner from './modules/full_screen_banner';
import row_contextmenu_dialog from './modules/row_contextmenu_dialog';
import preview from './modules/preview';
import mb_row_isShow from './modules/mb_row_isShow';
import historical from './modules/historical_records';
import anchor from './modules/anchor';
import searchs_params from './modules/searchs_params';
import atlas_look from './modules/atlas_look';
import font_style from './modules/font_style';
import page_add_row from './modules/page_add_row';
import map from './modules/map';
import moduleAnimation from  './modules/module_animation'
import vip from './modules/vip'
import draw_icon from './modules/draw_icon';
import right_set from './modules/right_set';
import login_type from './modules/login_type'
import language from './modules/language'
Vue.use(Vuex);

// 应用初始状态
const state = {
  options: options, //所有列表数据的配置
};
const mutations = {};

// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  modules: {
    myRender,
    app,
    row,
    left_sidebar,
    module,
    main_dialog,
    color,
    align,
    image_upload,
    set_link,
    full_screen_banner,
    add_form,
    add_form_item,
    row_contextmenu_dialog,
    preview,
    mb_row_isShow,
    historical,
    anchor,
    searchs_params,
    atlas_look,
    font_style,
    page_add_row,
    map,
    moduleAnimation,
    vip,
    draw_icon,
    right_set,
    login_type,
    language
  },
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js